import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
import "..//../../styles.css";
import Vectorsorting from "../../../assets/Vectorsorting.svg";
import ShimmerLoader from "../../../loading";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router-dom";
import CustomPagination from "../../../components/CustomWidgets/CustomPagination";
import arrowright from "../../../assets/arrowright.svg";
import { useSelector } from "react-redux";

const StockTransferHistoryTable = ({
  additionalData,
  pagination,
  onRowClick,
  onAccept,
  onCancel,
}) => {
  const { t, i18n } = useTranslation();
  const [flag, setflag] = useState(false);
  const navigate = useNavigate();
  const is_master_Store = useSelector(
    (state) => state?.login?.user?.result?.is_master_store
  );
  const masterStore = useSelector((state) => state.login.masterStore);
  const companyId = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );

  const openOrderList = (id) => {
    navigate(`/vendorDetails?id=${id}`);
  };

  const data = useMemo(
    () =>
      //   additionalData?.status
      //     ? additionalData?.all_product
      additionalData || [],
    [additionalData]
  );

  useEffect(() => {
    if (additionalData?.length === 0 && !flag) {
      const timer = setTimeout(() => {
        setflag(true);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [additionalData, flag]);
  console.log("data==>", data);

  const columns = useMemo(
    () => [
      {
        Header: (
          <div className="text-start justify-start" title={t("Date & Time")}>
            {t("Date & Time")}
          </div>
        ),
        width: "7%", // Add this line
        accessor: "create_date",
        headerClassName: "text-start",
        Cell: ({ row }) => (
          <div className="text-start justify-start">
            {row.original.create_date}
          </div>
        ),
      },

      {
        Header: (
          <div className="text-start" title={t("Order No.")}>
            {t("Order No.")}
          </div>
        ),
        width: "8%", // Add this line
        accessor: "order_no",
        Cell: ({ row }) => (
          <div className="text-start">{`${row.original.order_no}`}</div>
        ),
      },

      {
        Header: (
          <div className="text-start justify-start" title={t("Transfer From")}>
            {t("Transfer From")}
          </div>
        ),
        width: "8%", // Add this line
        accessor: "transfer_from",
        headerClassName: "text-start",
        Cell: ({ row }) => (
          <div className="text-start justify-start">
            {row.original.transfer_from}
          </div>
        ),
      },
      {
        Header: (
          <div className="text-start" title={t("Transfer To")}>
            {t("Transfer To")}
          </div>
        ),
        width: "8%", // Add this line
        accessor: "transfer_to",
        Cell: ({ row }) => (
          <div className="text-start">{`${row.original.transfer_to}`}</div>
        ),
      },

      {
        Header: (
          <div className="text-start" title={t("No. of Items")}>
            {t("No. of Items")}
          </div>
        ),
        width: "6%", // Add this line
        accessor: "no_of_items",
        Cell: ({ row }) => (
          <div className="text-start">{`${row.original.no_of_items}`}</div>
        ),
      },

      {
        Header: (
          <div className="text-start" title={t("Status")}>
            {t("Status")}
          </div>
        ),
        width: "10%",
        accessor: "status",
        Cell: ({ row }) => {
          const state = row.original.status;

          // Status text mapping
          let displayState = "";
          let bgColor = "";
          let textColor = "";

          switch (state) {
            case "Draft":
              displayState = "In Transit";
              bgColor = "bg-[#D6E9FF]"; // light blue
              textColor = "text-[#0070CC]"; // blue
              break;
            case "Done":
              displayState = "Received";
              bgColor = "bg-[#D1FFDE]"; // light green
              textColor = "text-[#00B833]"; // green
              break;
            case "Cancelled":
              displayState = "Cancelled";
              bgColor = "bg-[#FFD1D1]"; // light red
              textColor = "text-[#EF3A3A]"; // red
              break;
            default:
              displayState = state;
              bgColor = "bg-gray-100";
              textColor = "text-gray-800";
          }

          return (
            <div
              className={`text-start px-3 py-1 rounded-lg w-24 flex justify-start items-center ${bgColor} ${textColor}`}
            >
              {t(displayState)}
            </div>
          );
        },
      },

      {
        Header: (
          <div className="text-start" title={t("Action")}>
            {/* {t("Action")} */}
          </div>
        ),
        width: "6%",
        accessor: "is_accept",
        Cell: ({ row }) => {
          const state = row.original.status;
          const isAccept = row.original.is_accept;
          // Hide buttons if status is Done or Cancelled
          if (state === "Done" || state === "Cancelled") return null;

          // Master store & Draft → only show Cancel
          return (
            <div className="flex gap-2">
              {is_master_Store &&
                state === "Draft" &&
                masterStore?.store_id === companyId && (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      onCancel(row.original);
                    }}
                    className="px-3 py-1 rounded-md bg-red text-white text-sm"
                  >
                    {t("Cancel")}
                  </button>
                )}
              {((!is_master_Store &&
                state === "Draft" &&
                row.original.parent_company_id != companyId) ||
                (is_master_Store &&
                  state === "Draft" &&
                  //Uncomment if you dont want to accept from master store
                  //  row.original.child_company_id === masterStore?.store_id &&
                  row.original.parent_company_id != companyId)) && (
                <div className="flex gap-2">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      onAccept(row.original);
                    }}
                    className="px-3 py-1 rounded-md bg-[#1b4597] text-white text-sm"
                  >
                    {t("Accept")}
                  </button>
                </div>
              )}
            </div>
          );
        },
      },

      {
        id: "action",
        Header: "",
        headerClassName: "text-start",
        // width: 50,
        width: "4%", // Add this line
        accessor: (row) => `${row.original},`,
        Cell: ({ row }) => (
          <>
            <button
              className=" text-[#1b4497] rounded-lg"
              // onClick={() => openOrderList(row.original.order_details.order_no)}
            >
              <img
                src={arrowright}
                alt="arrowright"
                className={`${i18n.language == "en" ? "" : " rotate-180"}`}
                height={3}
                width={20}
              />
            </button>
            {/* )
                  } */}
          </>
        ),
      },
    ],
    [t]
  );

  const {
    headerGroups,
    prepareRow,
    page,
    nextPage,
    setPageSize,
    state: { pageSize },
  } = useTable(
    {
      columns,
      data: data,
      initialState: { pageSize: 20 },
    },
    useSortBy,
    usePagination,
    useRowSelect
  );

  const [pageIndex, setpageIndex] = useState(1);

  useEffect(() => {
    const pageDetails = {
      limit: pageSize,
      offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
    };

    if (pageSize) pagination(pageDetails);
  }, [pageSize, pageIndex]);

  return (
    <>
      <div
        className="container flex flex-col mx-auto mt-4"
        style={{ maxWidth: "100%" }}
      >
        {additionalData?.length == 0 && flag == false ? (
          <div className="h-screen w-[90%] mt-2 ">
            <ShimmerLoader />
          </div>
        ) : (
          <>
            {/* Header Table (Fixed) */}
            <div>
              <table
                className="font-normal  max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <thead>
                  {headerGroups.map((headerGroup, headerIndex) => {
                    const { key: headerKey, ...headerGroupProps } =
                      headerGroup.getHeaderGroupProps();
                    return (
                      <tr
                        key={headerKey}
                        {...headerGroupProps}
                        className="bg-[#78CFEC66] text-sm font-semibold overflow-hidden whitespace-nowrap"
                      >
                        {headerGroup.headers.map((column, colIndex) => {
                          const { key: columnKey, ...columnProps } =
                            column.getHeaderProps(
                              column.getSortByToggleProps()
                            );
                          return (
                            <th
                              key={columnKey}
                              {...columnProps}
                              className="py-3 whitespace-nowrap"
                              style={{ width: column.width }} // Set column width
                            >
                              <div className="flex items-start ms-2 text-sm ">
                                {column.render("Header")}
                                <span className="">
                                  {column.isSorted ? (
                                    column.isSortedDesc ? (
                                      <img
                                        src={Vectorsorting}
                                        style={{ minHeight: 10, minWidth: 10 }}
                                        alt="vector"
                                      />
                                    ) : (
                                      <img
                                        className="rotate-180"
                                        src={Vectorsorting}
                                        alt="vector"
                                      />
                                    )
                                  ) : (
                                    ""
                                  )}
                                </span>
                              </div>
                            </th>
                          );
                        })}
                      </tr>
                    );
                  })}
                </thead>
              </table>
            </div>

            {/* Body Table (Scrollable) */}
            <div
              className="scrollbar-none bg-white"
              style={{
                overflowY: "auto",
                maxHeight: "450px", // Adjust height as needed
              }}
            >
              <table
                className="font-normal max-w-[100%] sm:w-[97.6%]  md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                style={{ tableLayout: "fixed" }}
              >
                <tbody className="bg-[#F7F9FD] text-center overflow-hidden">
                  {page.map((row) => {
                    prepareRow(row);
                    return (
                      <React.Fragment key={row.id}>
                        <tr
                          {...row.getRowProps()}
                          className="relative hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300 fixed-row-height"
                          onClick={() => onRowClick && onRowClick(row.original)}
                          //   onClick={() => openOrderList(row.original.id)}
                        >
                          {row.cells.map((cell, index) => (
                            <td
                              key={index}
                              {...cell.getCellProps()}
                              className={`p-2 text-[#272728] h-1212 text-sm font-normal ${
                                index < row.cells.length - 1 ? "relative" : ""
                              } ${
                                cell?.column?.Header == "Product"
                                  ? "cursor-pointer"
                                  : ""
                              }`}
                              style={{ width: cell.column.width }} // Match column width
                            >
                              {cell.render("Cell")}
                            </td>
                          ))}
                        </tr>
                      </React.Fragment>
                    );
                  })}
                  {page.length === 0 && (
                    <tr>
                      <td colSpan={"100%"}>
                        <Empty
                          className="mt-10"
                          description={t("No data available")}
                        />
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* Pagination */}
            <div className="">
              <CustomPagination
                data={data?.length}
                pageIndex={pageIndex}
                pageCount={page?.length}
                canPreviousPage={pageIndex != 1 ? true : false}
                canNextPage={data?.length == pageSize ? true : false}
                gotoPage={(page) => {
                  nextPage(page);
                }}
                previousPage={() => {
                  setpageIndex(pageIndex - 1);
                }}
                nextPage={() => {
                  setpageIndex(pageIndex + 1);
                }}
                pageSize={pageSize}
                setPageSize={(pageSize) => {
                  setPageSize(pageSize);
                }}
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default StockTransferHistoryTable;
